import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ComplianceControl, ComplianceControlCreate, ComplianceControlFilter } from '../data/complianceControl';

export function createComplianceControlService(client: AxiosInstance) {
  return createCrudService<ComplianceControl, ComplianceControlCreate, ComplianceControlFilter>(
    client,
    '/audit/ComplianceControl',
    'id',
  );
}

export type ComplianceControlService = CrudService<ComplianceControl, ComplianceControlCreate, ComplianceControlFilter>;
